<template>
  <span>
    <img draggable="false" class="clickable" id="quit_btn_top" @click="goToInheemsStart()" src="./../../assets/images/Asset 58.png" alt="">
    <img draggable="false" class="background_image" src="./../../assets/images/inheems/Asset 1.png" alt="">
    <img draggable="false" id="game_drawer" src="./../../assets/images/inheems/Asset 5.png">

    <span v-if="selected_text == 0" id="inheems_game_text_intro_header">Dag der inheemsen</span>
    <span v-html="texts[selected_text]" id="inheems_game_intro_text" :style="selected_text > 0 ? 'margin-top: 16%;' : ''"></span>

    <img  draggable="false" class="clickable" v-show="texts.length > (selected_text + 1)" @click="nextText()" id="next_btn" src="./../../assets/images/Asset 51.png" alt="">
    <img  draggable="false" class="clickable" v-show="selected_text > 0" @click="prevText()" id="prev_btn" src="./../../assets/images/Asset 51.png" alt="">

    <img v-show=" ! $store.getters['app/overlays'].skip_intro ? texts.length == (selected_text + 1) : true"  draggable="false" @click="goToInheemsMenu()" class="clickable" id="inheems_game_intro_btn" src="./../../assets/images/Asset 30.png" alt="">
  </span>
</template>

<script>

export default {
  name: "InheemsIntro",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {
      selected_text: 0,
      texts: [
        "Wist je dat Suriname een plek is waar verschillende inheemse stammen leven? We hebben de Wayana, Trio en Akoerio in het zuiden en de Caraïben en Arowakken aan de kust. Op 9 augustus vieren we de \"Dag der Inheemsen\" om te laten zien hoe bijzonder ze zijn!",

        "Op deze speciale dag willen we iedereen laten zien hoe belangrijk het is om de rechten van inheemse mensen te erkennen en om respect voor hen te hebben, niet alleen hier in Suriname, maar over de hele wereld. In de prachtige Palmentuin kun je op 9 augustus genieten van een geweldig feest vol inheemse cultuur! Je kunt kijken naar prachtige dansen, luisteren naar betoverende zang en muziek, bewonderen hoe ze zich kleden en schitterende sieraden dragen. En als je dapper bent, kun je zelfs proeven hoe \"pepre watra\" smaakt, een bijzonder inheemse soep!",
        
        "Dus vraag je ouders of verzorgers om je op 9 augustus naar de Palmentuin te brengen, zodat je kunt leren en genieten van de geweldige inheemse cultuur."
      ]
    };
  },

  methods: {
    goToInheemsStart() {
      this.$router.push('/inheems/start');
    },
    goToInheemsMenu() {
      this.$store.dispatch('app/asyncUpdateSkipIntro', {
          skip_intro: true,
      });
      this.$router.push('/inheems/menu');
    },
    nextText() {
      this.selected_text++;
    },
    prevText() {
      this.selected_text--;
    },
  },

  computed: {}
};
</script>

<style>
  #inheems_game_text_intro_header {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 16%;
    width: 50%;
    left: 25%;
    color: #422818;
    font-size: 5vw;
    text-align: center;
  }
  #inheems_game_intro_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 23%;
    width: 50%;
    left: 25%;
    color: #422818;
    font-size: 2vw;
    text-align: center;
  }
  #game_drawer {
    position: absolute;
    margin-top: -0.5%;
    left: 15%;
    width: 70%;
  }
  .tembe_card {
    position: absolute;
    width: 25%;
    filter: drop-shadow(5px 5px 5px #3d3d3d);
    -webkit-filter: drop-shadow(5px 5px 5px #3d3d3d);
  }
  #tembe_card_1 {
    margin-top: 10%;
    left: 25%;
  }
  #inheems_game_intro_btn {
    position: absolute;
    margin-top: 42%;
    left: 44%;
    width: 13%;
  }
  #next_btn {
    position: absolute;
    margin-top: 44%;
    left: 73%;
    width: 5%;
  }
  #prev_btn {
    transform: rotate(180deg);
    position: absolute;
    margin-top: 44%;
    left: 20%;
    width: 5%;
  }
</style>


